import http from "@/settings/apiSettings";

class RU_PersonalDashboardDataService {
  getDashboard(): Promise<any> {
    return http.clientResurseUmane.get("/ru/personal-dashboard");
  }
}

export default new RU_PersonalDashboardDataService();
